import Vue from 'vue'
import Router from 'vue-router'

// -----------------------------------------
// Site
import SiteLayout from '@/layouts/SiteLayout'
//
import SiteRegister from '@/pages/SiteRegister'
import SiteForgotPassword from '@/pages/SiteForgotPassword'
import SiteChangePassword from '@/pages/SiteChangePassword'
import SiteLogin from '@/pages/SiteLogin'
import SiteReportsLogin from '@/pages/SiteReportsLogin'

// -----------------------------------------
// Other Layout
import InsightsLayout from '@/layouts/InsightsLayout'
import AboutLayout from '@/layouts/AboutLayout'
import SupportLayout from '@/layouts/SupportLayout'
import LogoutLayout from '@/layouts/LogoutLayout'
import RedirectProtectedContentLayout from '@/layouts/RedirectProtectedContentLayout'
import RedirectLoginLayout from '@/layouts/RedirectLoginLayout'
import Error404 from '@/pages/404'

// -----------------------------------------
// Session Viewer
const SessionViewerLayout = () => import(/* webpackChunkName: "SessionViewerSection" */ '@/layouts/SessionViewerLayout')

// -----------------------------------------
// Campaigns List
const CampaignsLayout = () => import(/* webpackChunkName: "CampaignListSection" */ '@/layouts/CampaignsLayout')

// -----------------------------------------
// Campaigns Edit
const CampaignEditLayout = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/layouts/CampaignEditLayout')
//
const CampaignEditDetails = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditDetails')
const CampaignEditOffers = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditOffers')
const CampaignEditOffersList = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditOffersList')
const CampaignEditOffersEdit = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditOffersEdit')
const CampaignEditSegmentation = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditSegmentation')
const CampaignEditSegmentationList = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditSegmentationList')
const CampaignEditSegmentationEdit = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditSegmentationEdit')
const CampaignEditSegmentActions = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditSegmentActions')
const CampaignEditDomains = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditDomains')
const CampaignEditOptions = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditOptions')
const CampaignEditPublish = () => import(/* webpackChunkName: "CampaignEditSection" */ '@/pages/CampaignEditPublish')
const SegmentationBulkEdit = () => import(/* webpackChunkName: "SegmentationBulkEdit" */ '@/pages/SegmentationBulkEdit')
const OfferBulkEdit = () => import(/* webpackChunName: "OfferBulkEdit" */ '@/pages/OfferBulkEdit')

// -----------------------------------------
// Account
const AccountLayout = () => import(/* webpackChunkName: "AccountSection" */ '@/layouts/AccountLayout')
//
const AccountProfile = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountProfile')
const AccountChangePassword = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountChangePassword')
const AccountCompany = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountCompany')
const AccountUsers = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountUsers')
const AccountAgency = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountAgency')
const AccountPreferences = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountPreferences')
const AccountSecurity = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountSecurity')
const AccountShopLinks = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountShopLinks')
const AccountDomains = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountDomains')
const AccountTransactions = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountTransactions')
const AccountConversions = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountConversions')
const AccountInvoices = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountInvoices')
const AccountEndpoints = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountEndpoints')
const AccountSharedRulesetsList = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountSharedRulesetsList')
const AccountSharedRulesetsEdit = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountSharedRulesetsEdit')
const AccountFormResponses = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountFormResponses')
const AccountCustomData = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountCustomData')
const AccountSummaryEmails = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountSummaryEmails')
const AccountExportEmails = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountExportEmails')
const AccountDownloads = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountDownloads')
const AccountConversionDefinitions = () => import(/* webpackChunkName: "AccountSection" */ '@/pages/AccountConversionDefinitions')

const AccountStreams = () => import(/* webpackChunkName: "AccountSectionStreams" */ '@/pages/AccountStreams')
const AccountStreamsList = () => import(/* webpackChunkName: "AccountSectionStreams" */ '@/apps/streamApp/components/ListView')
const AccountStreamsEdit = () => import(/* webpackChunkName: "AccountSectionStreams" */ '@/apps/streamApp/components/EditorView')

// -----------------------------------------
// Notifications
const NotificationsApp = () => import(/* webpackChunkName: "NotificationsSection" */ '@/apps/notifications/App.vue')
const NotificationsDashboard = () => import(/* webpackChunkName: "NotificationsSection" */ '@/apps/notifications/views/Dashboard.vue')
const NotificationsEdit = () => import(/* webpackChunkName: "NotificationsSection" */ '@/apps/notifications/views/Edit.vue')
const NotificationsList = () => import(/* webpackChunkName: "NotificationsSection" */ '@/apps/notifications/views/List.vue')
const NotificationsSettings = () => import(/* webpackChunkName: "NotificationsSection" */ '@/apps/notifications/views/Settings.vue')

// -----------------------------------------
// Translations
const TranslationsLayout = () => import(/* webpackChunkName: "TranslationsSection" */ '@/layouts/TranslationsLayout')

// -----------------------------------------
const NoSmartLayout = () => import(/* webpackChunkName: "NoSmartSection" */ '@/layouts/NoSmartLayout')

Vue.use(Router)

export default new Router({
  routes: [
    {
      // catch all instead of 404 ?
      path: '*',
      component: Error404,
    },
    {
      path: '/',
      name: 'Home',
      redirect: 'insights'
    },
    {
      path: '/insights/',
      name: 'Insights',
      component: InsightsLayout,
    },
    {
      path: '/campaigns/',
      name: 'Campaigns',
      component: CampaignsLayout,
    },
    {
      path: '/translations/',
      name: 'Translations',
      component: TranslationsLayout,
    },
    {
      path: '/notEnabled/',
      name: 'NotEnabled',
      component: NoSmartLayout,
    },
    {
      path: '/notifications',
      redirect: '/notifications/dashboard',
      name: 'Notifications',
      component: NotificationsApp,
      children: [
        {
          path: 'dashboard',
          name: 'NotificationsDashboard',
          component: NotificationsDashboard
        },
        {
          path: 'edit/id/:id/',
          redirect: 'edit/id/:id/page/filters/'
        },
        {
          path: 'edit/id/:id/page/:page/',
          name: 'Edit',
          component: NotificationsEdit,
        },
        {
          path: 'list/',
          redirect: 'list/type/manual/',
        },
        {
          path: 'list/type/manual/',
          redirect: 'list/type/manual/status/draft/',
        },
        {
          path: 'list/type/template/',
          redirect: 'list/type/template/status/draft/',
        },
        {
          path: 'list/type/:type/status/:status/',
          name: 'List',
          component: NotificationsList,
        },
        {
          path: 'list-triggered/',
          redirect: 'list-triggered/status/draft/',
        },
        {
          path: '/notifications/settings/',
          name: 'Settings',
          component: NotificationsSettings,
        }
      ]
    },
    {
      path: '/support/',
      name: 'SupportLayout',
      component: SupportLayout,
    },
    {
      path: '/about/',
      name: 'AboutLayout',
      component: AboutLayout,
    },
    {
      path: '/logout/',
      name: 'LogoutLayout',
      component: LogoutLayout,
    },
    {
      path: '/redirectProtectedContent/',
      name: 'RedirectProtectedContentLayout',
      component: RedirectProtectedContentLayout,
    },
    {
      path: '/campaigns/:id',
      redirect: '/campaigns/:id/details',
      name: 'CampaignEditLayout',
      component: CampaignEditLayout,
      children: [
        {
          path: 'details',
          name: 'CampaignEditDetails',
          component: CampaignEditDetails
        },
        {
          path: 'offers',
          redirect: '/campaigns/:id/offers/list',
          name: 'CampaignEditOffers',
          component: CampaignEditOffers,
          children: [
            {
              path: 'list',
              name: 'CampaignEditOffersList',
              component: CampaignEditOffersList
            },
            {
              path: 'edit/:offerId',
              name: 'CampaignEditOffersEdit',
              component: CampaignEditOffersEdit
            },
            {
              path: 'create',
              name: 'CampaignEditOffersCreate',
              component: CampaignEditOffersEdit
            },
            {
              path: 'bulkEdit',
              name: 'OfferBulkEdit',
              component: OfferBulkEdit
            }
          ]
        },
        {
          path: 'segmentation',
          redirect: '/campaigns/:id/segmentation/list',
          name: 'CampaignEditSegmentation',
          component: CampaignEditSegmentation,
          children: [
            {
              path: 'segment/:segmentId',
              name: 'CampaignEditSegmentationEdit',
              component: CampaignEditSegmentationEdit
            },
            {
              path: 'list',
              name: 'CampaignEditSegmentationList',
              component: CampaignEditSegmentationList
            },
            {
              path: 'bulkEdit',
              name: 'SegmentationBulkEdit',
              component: SegmentationBulkEdit
            }
          ]
        },
        {
          path: 'segmentActions',
          name: 'CampaignEditSegmentActions',
          component: CampaignEditSegmentActions
        },
        {
          path: 'domains',
          name: 'CampaignEditDomains',
          component: CampaignEditDomains
        },
        {
          path: 'options',
          name: 'CampaignEditOptions',
          component: CampaignEditOptions
        },
        {
          path: 'publish',
          name: 'CampaignEditPublish',
          component: CampaignEditPublish
        },
      ]
    },
    {
      path: '/account',
      redirect: '/account/profile',
      name: 'AccountLayout',
      component: AccountLayout,
      children: [
        {
          path: 'profile',
          name: 'AccountProfile',
          component: AccountProfile
        },
        {
          path: 'changePassword',
          name: 'AccountChangePassword',
          component: AccountChangePassword
        },
        {
          path: 'company',
          name: 'AccountCompany',
          component: AccountCompany
        },
        {
          path: 'users',
          name: 'AccountUsers',
          component: AccountUsers
        },
        {
          path: 'agency',
          name: 'AccountAgency',
          component: AccountAgency
        },
        {
          path: 'agency/link/id/:id/accept/:accept/',
          name: 'AccountAgencyLink',
          component: AccountAgency
        },
        {
          path: 'preferences',
          name: 'AccountPreferences',
          component: AccountPreferences
        },
        {
          path: 'security',
          name: 'AccountSecurity',
          component: AccountSecurity
        },
        {
          path: 'shopLinks',
        name: 'AccountShopLinks',
          component: AccountShopLinks
        },
        {
          path: 'domains',
          name: 'AccountDomains',
          component: AccountDomains
        },
        {
          path: 'conversions',
          name: 'AccountConversions',
          component: AccountConversions
        },
        {
          path: 'transactions',
          name: 'AccountTransactions',
          component: AccountTransactions
        },
        {
          path: 'invoices',
          name: 'AccountInvoices',
          component: AccountInvoices
        },
        {
          path: 'endpoints',
          name: 'AccountEndpoints',
          component: AccountEndpoints
        },
        {
          path: 'streams',
          name: 'AccountStreams',
          component: AccountStreams,
          redirect: '/account/streams/list/',
          children: [
            {
              path: 'list',
              component: AccountStreamsList
            },
            {
              path: 'edit/:streamId',
              component: AccountStreamsEdit
            },
          ]
        },
        {
          path: 'sharedRulesets',
          name: 'AccountSharedRulesetsList',
          component: AccountSharedRulesetsList
        },
        {
          path: 'sharedRulesets/edit/:rulesetId',
          name: 'AccountSharedRulesetsEdit',
          component: AccountSharedRulesetsEdit
        },
        {
          path: 'formResponses',
          name: 'AccountFormResponses',
          component: AccountFormResponses
        },
        {
          path: 'customData',
          name: 'AccountCustomData',
          component: AccountCustomData
        },
        {
          path: 'summaryEmails',
          name: 'AccountSummaryEmails',
          component: AccountSummaryEmails
        },
        {
          path: 'exportEmails',
          name: 'AccountExportEmails',
          component: AccountExportEmails
        },
        {
          path: 'downloads',
          name: 'AccountDownloads',
          component: AccountDownloads
        },
        {
          path: 'conversion-definitions',
          name: 'AccountConversionDefinitions',
          component: AccountConversionDefinitions
        }
      ]
    },
    {
      path: '/sessionViewer/',
      name: 'SessionViewerLayout',
      component: SessionViewerLayout
    },
    {
      path: '/redirectLogin/',
      name: 'RedirectLoginLayout',
      component: RedirectLoginLayout,
    },
    {
      path: '/site',
      redirect: '/site/register',
      name: 'SiteLayout',
      component: SiteLayout,
      children: [
        {
          path: 'login',
          name: 'SiteLogin',
          component: SiteLogin
        },        
        {
          path: 'register',
          name: 'SiteRegister',
          component: SiteRegister
        },
        {
          path: 'forgotPassword',
          name: 'SiteForgotPassword',
          component: SiteForgotPassword
        },
        {
          path: 'changePassword/id/:id/hash/:hash',
          name: 'SiteChangePassword',
          component: SiteChangePassword
        },
        {
          path: 'reportsLogin/accountId/:accountId/onBehalfOfAccountId/:onBehalfOfAccountId/email/:email/hash/:hash/ts/:ts/',
          name: 'SiteReportsLogin',
          component: SiteReportsLogin
        }
      ]
    }
  ]
})